export default __webpack_public_path__ + "static/media/live-icon-active.e843d626.webp";